import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import React from 'react'
import { NavLink } from 'react-router-dom'
import Navbar from '../Common/Navbar'
import Commerce from './Commerce'
import Marketing from './Marketing'
import Transactions from './Transactions'

function Pricing() {
  return (
    <>
    <Navbar/>
      <Box>
        <Tabs size="lg" align="center" variant="line">
          <TabList  mb='1em' bgColor="#ffe01b">
            <Tab p="1rem 5rem" _selected={{ color: 'black', bg: 'white' }}><NavLink to="/pricing/marketing">Marketing Platform</NavLink></Tab>
            <Tab p="1rem 5rem" _selected={{ color: 'black', bg: 'white' }}><NavLink to="/pricing/commerce">Websites & Commerce</NavLink></Tab>
            <Tab p="1rem 5rem" _selected={{ color: 'black', bg: 'white' }}><NavLink to="/pricing/transactional-email">Transactional Email</NavLink></Tab>
          </TabList>
          <TabPanels >
            <TabPanel>
              <Marketing/>
            </TabPanel>
            <TabPanel>
              <Commerce/>
            </TabPanel>
            <TabPanel>
              <Transactions/>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </>
  )
}

export default Pricing